var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMvInfo01 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "mv_info_01_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h80v80H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#mv_info_01_svg__a)",
  "data-name": "Group 157"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M59.351 57.144a11.108 11.108 0 0 0 1.085-22.163 18.381 18.381 0 0 0-35.64-5.909c-.246-.013-.49-.038-.74-.038a14.055 14.055 0 1 0 0 28.11h11.656",
  "data-name": "Path 205"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 156"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m47.334 41.034 9.346 4.23s1.642 13.135-9.346 17.853c-10.988-4.718-9.346-17.853-9.346-17.853Z",
  "data-name": "Path 206"
})), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "m43.34 52.067 2.94 2.783 5.395-5.394",
  "data-name": "Path 207"
}))));
export { SvgMvInfo01 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCI+CiAgPGRlZnM+CiAgICA8Y2xpcFBhdGggaWQ9ImNsaXAtY2xvdWRfc2VydmljZV93aGl0ZSI+CiAgICAgIDxyZWN0IHdpZHRoPSI4MCIgaGVpZ2h0PSI4MCIvPgogICAgPC9jbGlwUGF0aD4KICA8L2RlZnM+CiAgPGcgaWQ9ImNsb3VkX3NlcnZpY2Vfd2hpdGUiIGNsaXAtcGF0aD0idXJsKCNjbGlwLWNsb3VkX3NlcnZpY2Vfd2hpdGUpIj4KICAgIDxnIGlkPSJHcm91cF8xNTciIGRhdGEtbmFtZT0iR3JvdXAgMTU3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjEwLjk4OCAtMzQyLjQ5MikiPgogICAgICA8cGF0aCBpZD0iUGF0aF8yMDUiIGRhdGEtbmFtZT0iUGF0aCAyMDUiIGQ9Ik02NzAuMzM5LDM5OS42MzZhMTEuMTA4LDExLjEwOCwwLDAsMCwxLjA4NS0yMi4xNjMsMTguMzgxLDE4LjM4MSwwLDAsMC0zNS42NC01LjkwOWMtLjI0Ni0uMDEzLS40OS0uMDM4LS43NC0uMDM4YTE0LjA1NSwxNC4wNTUsMCwxLDAsMCwyOC4xMUg2NDYuNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgIDxnIGlkPSJHcm91cF8xNTYiIGRhdGEtbmFtZT0iR3JvdXAgMTU2IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg2NDguODg5IDM4NC41MjYpIj4KICAgICAgICA8cGF0aCBpZD0iUGF0aF8yMDYiIGRhdGEtbmFtZT0iUGF0aCAyMDYiIGQ9Ik02NzEuNDE1LDM5My4xMDVsOS4zNDYsNC4yM3MxLjY0MiwxMy4xMzUtOS4zNDYsMTcuODUzYy0xMC45ODgtNC43MTgtOS4zNDYtMTcuODUzLTkuMzQ2LTE3Ljg1M1oiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC02NjEuOTgyIC0zOTQuMTA1KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICAgIDwvZz4KICAgICAgPHBhdGggaWQ9IlBhdGhfMjA3IiBkYXRhLW5hbWU9IlBhdGggMjA3IiBkPSJNNjcwLjA3OCw0MDguOTQ1bDIuOTQsMi43ODMsNS4zOTUtNS4zOTQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xNS43NSAtMTQuMzg2KSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSIyIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";